module.exports = __webpack_public_path__ + "static/media/seta-biografia-vermelha.a7338bf2.svg";